
export default {
  props: {
    selectedItems: {
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
      alert: {
        show: false,
        message: '',
        variant: ''
      },
      formData: {
        customerName: '',
        lastName: '',
        phoneNo: '',
        companyName: '',
        province: '',
        email: '',
        productList: '',
        description: '',
      },
    }
  },
  methods: {
    showAlert(message, variant) {
      this.alert = {
        show: true,
        message,
        variant
      }
      
      // Hide alert after 5 seconds
      setTimeout(() => {
        this.alert.show = false
      }, 5000)
    },

    resetForm() {
      this.formData = {
        customerName: '',
        lastName: '',
        phoneNo: '',
        companyName: '',
        province: '',
        email: '',
        productList: '',
        description: '',
      }
    },

    async SEND_MAIL(e) {
      e.preventDefault()
      this.loading = true

      try {
        const response = await this.$axios.post('/api/send-email', {
          subject: 'Vabody.com Information Form',
          formData: {
            customerName: this.formData.customerName + ' ' + this.formData.lastName,
            phoneNo: this.formData.phoneNo,
            companyName: this.formData.companyName,
            province: this.formData.province,
            email: this.formData.email,
            productList: this.selectedItems
              .map((item) => item.title)
              .join(', '),
            description: this.formData.description,
          },
        })

        this.showAlert('Your message has been sent successfully!', 'success')
        this.resetForm()
      } catch (error) {
        this.showAlert('Failed to send message. Please try again.', 'error')
        console.error(error)
      } finally {
        this.loading = false
      }
    },
  },
}
